<template>
  <transition name='slide-fade'>
    <div class='page-component-up' v-if='isShow' @click='getTop'>
      <img src="../../assets/imgs/homepage/top.png">
    </div>
  </transition>
</template>
<script>
export default {
  name: 'BackTop',
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    showIcon () {
      if (document.documentElement.scrollTop > 100) {
        this.isShow = true
      } else if (document.documentElement.scrollTop < 100) {
        this.isShow = false
      }
    },
    getTop () {
      let timer = setInterval(() => {
        let top = document.documentElement.scrollTop
        let speed = Math.ceil(top / 5)
        document.documentElement.scrollTop = top - speed
        if (top === 0) {
          clearInterval(timer)
        }
      }, 20)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.showIcon)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.showIcon)
  }
}
</script>

<style lang="less" scoped>
.slide-fade-enter-active {
  transition: all 0.1s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.3, 0.8, 1);
  opacity: 0;
}
.slide-fade-enter,
.slide-fade-leave-to {
  // transform: translateY(-20px);
  opacity: 0;
}
.page-component-up {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #5f97ff;
  box-shadow: 0px 0px 10px 0px rgba(95, 151, 255, 0.5);
  position: fixed;
  right: 5.2vw;
  bottom: 6.1vw;
  width: 3.1vw;
  height: 3.1vw;
  cursor: pointer;
  transition: 0.3s;
  text-align: center;
  z-index: 999;
  img {
    width: 2vw;
    height: 2vw;
  }
}
</style>